import { render, staticRenderFns } from "./EditTextComponent.vue?vue&type=template&id=1f214b63&scoped=true&"
import script from "./EditTextComponent.vue?vue&type=script&lang=js&"
export * from "./EditTextComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditTextComponent.vue?vue&type=style&index=0&id=1f214b63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f214b63",
  null
  
)

export default component.exports